





























import { Component, Vue } from "vue-property-decorator";
import { FeriadosService, Feriado } from "@/services/feriados.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import DatePicker from "@/shared/components/date-picker.vue";
import dayjs from "dayjs";
@Component({
  components: {
    Loading,
    Modal,
    DatePicker,
  },
})
export default class Manter extends Vue {
  feriado: Feriado | null = null;
  data = "";
  loading = false;
  rules = {
    descricao: [required()],
    data: [required()],
  };

  get tituloManter(): string {
    if (this.feriado) {
      return this.feriado.idFeriado == null
        ? "Novo Feriado"
        : "Alterar Feriado";
    }
    return "";
  }

  public async editarFeriado(id: number) {
    const modal = this.$refs.modal as Modal;
    this.feriado = await FeriadosService.obterFeriado(id);
    this.data = `${this.feriado.ano}-${this.feriado.mes}-${this.feriado.dia}`;
    return modal.open();
  }

  async salvarFeriado() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      if (this.feriado) {
        this.formataDataFeriado();
        await FeriadosService.alterarFeriado(this.feriado).finally(() => {
          this.loading = false;
        });
      }
      this.loading = false;
      return modal.close(true);
    }
  }

  public async novoFeriado() {
    const modal = this.$refs.modal as Modal;
    this.feriado = {} as Feriado;
    return modal.open();
  }

  formataDataFeriado() {
    const dataAux = dayjs(this.data, "YYYY-MM-DD");
    if (this.feriado) {
      this.feriado.ano = Number(dataAux.year());
      this.feriado.mes = Number(dataAux.month() + 1);
      this.feriado.dia = Number(dataAux.date());
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }
}
